"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButton = exports.ActionsContainer = exports.Preview = exports.InnerContainer = exports.Container = exports.PreviewContainer = exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var fixDragOverFlickering = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  pointer-events: none;\n"], ["\n  pointer-events: none;\n"])));
var SharedContainer = (0, styled_components_1.default)(ui_box_1.Box).attrs({
  cornerRadius: 'lg',
  mb: 1
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  overflow: hidden;\n  position: relative;\n  width: ", "px;\n  height: ", "px;\n"], ["\n  overflow: hidden;\n  position: relative;\n  width: ", "px;\n  height: ", "px;\n"])), function (_a) {
  var width = _a.width;
  return width;
}, function (_a) {
  var height = _a.height;
  return height;
});
exports.PreviewContainer = SharedContainer;
exports.Container = (0, styled_components_1.default)(SharedContainer)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n  background: ", ";\n  border: 1px dashed ", ";\n  transition: border 0.2s ease-in-out, background 0.2s ease-in-out;\n\n  ", "\n\n  ", "\n\n  ", ", ", " {\n    ", "\n  }\n"], ["\n  position: relative;\n  cursor: pointer;\n  background: ", ";\n  border: 1px dashed ", ";\n  transition: border 0.2s ease-in-out, background 0.2s ease-in-out;\n\n  ", "\n\n  ", "\n\n  ", ", ", " {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.LIGHT', theme);
}, function (_a) {
  var hoverEnabled = _a.hoverEnabled;
  return hoverEnabled && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      &:hover {\n        background: ", ";\n      }\n    "], ["\n      &:hover {\n        background: ", ";\n      }\n    "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.100', theme);
  });
}, function (_a) {
  var isDragOver = _a.isDragOver,
      hoverEnabled = _a.hoverEnabled;
  return isDragOver && hoverEnabled && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      background: ", ";\n      border: 2px dashed\n        ", ";\n    "], ["\n      background: ", ";\n      border: 2px dashed\n        ", ";\n    "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE.100', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.THEME.PRIMARY', theme);
  });
}, ui_text_1.Text, ui_icon_1.Icon, fixDragOverFlickering);
exports.InnerContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
})(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
exports.Preview = styled_components_1.default.img(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* or object-fit: contain; */\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* or object-fit: contain; */\n"])));
exports.ActionsContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  flexDirection: 'row-reverse'
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 1rem;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 1rem;\n"])));
exports.ActionButton = (0, styled_components_1.default)(ui_butticon_1.Butticon)(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  padding: 1px 6px;\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  background: ", ";\n  padding: 1px 6px;\n  &:hover {\n    background: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DEFAULT', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.700', theme);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;